import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute, redirect } from "@tanstack/react-router";

import { CustomersTable } from "~/components/child/customers-table";
import { ReferralLinkCard } from "~/components/child/referral-link-card";
import { Page, PageHeader, Section } from "~/components/shell/page";
import { customersQueryOptions } from "~/lib/api/customers";
import { isParent, meQueryOptions } from "~/lib/api/me";

export const Route = createFileRoute("/_authenticated/klanten")({
  beforeLoad: ({ context }) => {
    if (isParent(context.partner)) throw redirect({ to: "/overzicht" });
  },
  loader: async ({ context }) => {
    await context.queryClient.query(customersQueryOptions());
  },
  component: CustomersPage,
});

function CustomersPage() {
  const { data: partner } = useSuspenseQuery(meQueryOptions());
  const { data: customers } = useSuspenseQuery(customersQueryOptions());

  return (
    <Page>
      <PageHeader title="Klanten">
        Alle klanten die jij hebt aangebracht bij Lekkerladen, de nieuwste bovenaan.
      </PageHeader>

      <ReferralLinkCard
        referralCode={partner.referralCode ?? ""}
        customerCount={customers.length}
      />

      <Section
        title="Aangebrachte klanten"
        description="Alleen de klanten die jij hebt aangebracht. Je wervingspartner ziet deze lijst niet."
      >
        <CustomersTable customers={customers} />
      </Section>
    </Page>
  );
}
